<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <StartInfosForm :baseStartInfo="startInfo" :baseStartInfoName="name" :loading="loading" @submit-requested="submitRequested"></StartInfosForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StartInfosForm from './StartInfosForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            startInfo: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { StartInfosForm },
    computed:
    {
        ...mapState('startInfos', ['getStartInfoDetailsOutput']),
    },
    methods: {
        ...mapActions('startInfos', ['getStartInfoDetails']),
        ...mapActions('startInfos', ['putStartInfo']),
        submitRequested(startInfo) {
            this.putStartInfo(startInfo);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'StartInfosList' });
        }

        this.getStartInfoDetails(this.$route.query.id);
    },
    watch:
    {
        getStartInfoDetailsOutput: function(startInfoOutput)
        {
            if(!startInfoOutput && !startInfoOutput.data)
            {
                router.push({ name: 'StartInfosList' });
            }
            else
            {
                this.startInfo = startInfoOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>